export default __webpack_public_path__ + "static/media/diners.d18fff22.svg";